import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

/**
 * Soft deletes a line item from a contract.
 *
 * @param contractId - The UUID of the contract containing the item.
 * @param itemId - The UUID of the item to delete.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/delete_contract_item_contracts__contract_id__items__item_id__delete
 */
export const deleteContractItem = async (contractId: UUID, itemId: UUID) => {
  await vestigasApi.delete(ENDPOINT.CONTRACT_ITEM.DELETE(contractId, itemId));
};
